
import { defineComponent, defineAsyncComponent } from "vue";
import HomeExample from "../components/HomeExample.vue";
import ExampleContainer from "../components/ExampleContainer.vue";

export default defineComponent({
  name: "App",
  components: {
    HomeExample,
    ExampleContainer,
    Source: defineAsyncComponent(async () => {
      const component = await import("../components/Source.vue");

      return component.default;
    })
  },
  data() {
    return {
      str: require("!!raw-loader!../snippets/example.html").default
    };
  }
});
